/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_file_hwp': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><path pid="1" d="M7.438 14.87v-1.827H6V16h8v-1.13H7.438zm1.798-9.13H6.36v1.13h7.19V5.74h-2.876V4H9.236v1.74zM0 0h20v20H0V0zm10.045 14.087c.496 0 .899-.39.899-.87s-.403-.87-.9-.87c-.495 0-.898.39-.898.87s.403.87.899.87zm0-2.087c1.49 0 2.697-1.012 2.697-2.26 0-1.25-1.208-2.262-2.697-2.262-1.49 0-2.697 1.012-2.697 2.261S8.556 12 10.045 12zm0-1.13c-.645 0-1.169-.507-1.169-1.13 0-.625.524-1.131 1.169-1.131s1.168.506 1.168 1.13c0 .624-.523 1.13-1.168 1.13z" _fill="#1D9AD6"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_file_hwp.js